// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"77b8fa1f","618":"36b798c0"}[chunkId] + ".chunk.js";
};